import {Injectable, Inject} from '@angular/core';


@Injectable()
export class StsConfigService {


  private defaults = {
    isProduction: false,
    siteKey: '6LcHlxcUAAAAAAOFjzeOtp41qBM_DE-4fz_JB1Jo'
  };

  constructor () {
    this.defaults.isProduction = this.getBase().match(/\/MustAuthLogin\//ig) != null;
  }

  public getBase(): string {
    let b = document.getElementsByTagName('base');
    return b && b[0] ? b[0]['href'] : '/';
  }

  public isProduction(): boolean {
    return this.defaults['isProduction'];
  }

  public normalizePath(path: string): string {
    if (!this.isProduction()) { return path; }
    if (path.match(/^\//) != null) { path = path.replace(/^\//, ''); }
    return this.getBase() + path;
  }

  public getSiteKey() {
    return this.getSiteKey;
  }

}
